module.exports = __webpack_public_path__ + "img/smtffranchising-white-text-only-powered.e19095cf.png";